import { borderRadius, palette, spaces } from '@kimuno/theme';
import { Box, IconButton, Popper, SvgIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import getMuiIcon from '../../utils/getMuiIcon';

const ARROW_SIZE = 12;

interface SchoolAdminHintProps {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
}

const SchoolAdminHint = ({ anchorEl, open, onClose }: SchoolAdminHintProps) => {
	const { t } = useTranslation();

	return (
		<Popper
			open={open}
			anchorEl={anchorEl}
			placement="bottom-end"
			modifiers={[{ name: 'offset', options: { offset: [0, ARROW_SIZE] } }]}
			// Above the page chrome, below modal dialogs.
			sx={{ zIndex: (theme) => theme.zIndex.modal - 1 }}
		>
			<Box
				role="dialog"
				aria-labelledby="school-admin-hint-title"
				sx={{
					position: 'relative',
					maxWidth: 340,
					padding: spaces.md,
					paddingRight: spaces.xxl,
					borderRadius: borderRadius.sm,
					backgroundColor: palette.primary.main,
					color: palette.primary.contrastText,
					// The arrow points up at the avatar's centre (avatar is 40px wide).
					'&::before': {
						content: '""',
						position: 'absolute',
						top: -ARROW_SIZE / 2,
						right: 20 - ARROW_SIZE / 2,
						width: ARROW_SIZE,
						height: ARROW_SIZE,
						backgroundColor: palette.primary.main,
						transform: 'rotate(45deg)',
					},
				}}
			>
				<Typography id="school-admin-hint-title" variant="h6" component="p" color="inherit">
					{t('You are now an admin of your school licence!')}
				</Typography>
				<Typography variant="body2" color="inherit" sx={{ marginTop: spaces.xxs }}>
					{t('In the admin area you can now invite and manage teachers.')}
				</Typography>
				<IconButton
					aria-label={t('Close')}
					onClick={onClose}
					size="small"
					sx={{ position: 'absolute', top: spaces.xs, right: spaces.xs, color: 'inherit' }}
				>
					<SvgIcon component={getMuiIcon('close')} fontSize="small" />
				</IconButton>
			</Box>
		</Popper>
	);
};

export default SchoolAdminHint;
